export const DateModalContent = {
  SelectTimeBtn: 'select-time-btn',
} as const;
